<template>
  <div>
    <item-index :val="profile.val" :name="profile.name"></item-index>
    <img :src="picture" alt="" style="width: 100%; border-radius: 3px" />
    <div style="color: #cfe3ef; font-size: 12px; height: 100px">
      {{ profile.desc }}
    </div>

    <div
      v-for="li in list"
      :key="li.date"
      style="line-height: 28px; font-size: 12px; border-top: dashed 1px #4f4f66"
    >
      <div style="float: left; width: 50px; color: #9f9f9f">{{ li.date }}</div>
      <div style="float: left; width: 150px; color: #9fafbf">
        {{ li.point }}
      </div>
      <div style="float: right; width: 50px; text-align: right; color: #9fafbf">
        <span v-if="li.result" style="color: #c399a3"> 疑似 </span>
        <span v-else style="color: #99c3a3">正常</span>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>
<script>
import ItemIndex from './item-index.vue'
export default {
  components: { ItemIndex },
  props: ['profile'],
  computed: {
    picture() {
      const { picture } = this.profile
      return `http://picture.zkhfzhnyg.cn/digiberry/feature/${
        picture || '_blank.png'
      }`
    },
    list() {
      const points = [
        '农业谷大棚1分区',
        '农业谷大棚2分区',
        '农业谷大棚3分区',
        '草莓小镇温室种植区',
        '草莓小镇温室育苗区',
      ]
      let arr = [
        '01-03',
        '01-02',
        '01-01',
        '12-31',
        '12-30',
        '12-29',
        '12-28',
        '12-27',
        '12-26',
        '12-25',
        '12-24',
        '12-23',
        '12-22',
        '12-21',
        '12-20',
        '12-19',
        '12-18',
        '12-17',
        '12-16',
        '12-15',
        '12-14',
        '12-13',
        '12-12',
        '12-11',
        '12-10',
        '12-09',
        '12-08',
        '12-07',
        '12-06',
        '12-05',
        '12-04',
        '12-03',
        '12-02',
        '12-01',
        '11-30',
        '11-29',
        '11-28',
        '11-27',
        '11-26',
        '11-25',
        '11-24',
        '11-23',
        '11-22',
        '11-21',
        '11-20',
      ]
      while (arr.length > 10) {
        const r = parseInt(Math.random() * arr.length)
        arr.splice(r, 1)
      }
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i]
        const point = points[parseInt(Math.random() * points.length)]
        const result = Math.random() > 0.9
        arr[i] = {
          date: element,
          point: point,
          result: result,
        }
      }
      return arr
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/disease/list/item.vue